import { useTranslation } from 'react-i18next';
import { SuccessNotice } from '@/components/successNotice';
import { useControlCenter } from './useControlCenter';

export const ControlCenterFeedback = () => {
    const { t } = useTranslation('pages');
    const { outcome, onDismissOutcome } = useControlCenter();

    if (!outcome) {
        return null;
    }

    return (
        <div className="mb-6">
            <SuccessNotice
                action={{ label: t(outcome.linkKey), to: outcome.to }}
                dismissLabel={t('controlCenter.outcome.dismiss')}
                message={t(outcome.messageKey, outcome.messageParams)}
                onDismiss={onDismissOutcome}
                testId="control-center-outcome"
            />
        </div>
    );
};
